import { ComponentProps } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { twMerge } from 'tailwind-merge';
import { COLORS } from '@/constants/COLORS';

type TierAvatarProgressProps = {
  children: React.ReactNode;
  progressPercentage: number | null;
  small?: boolean;
} & ComponentProps<'div'>;

const TierAvatarProgress = ({ children, progressPercentage, small, className }: TierAvatarProgressProps) => {
  return (
    <div className={className}>
      <CircularProgressbarWithChildren
        value={progressPercentage || 0}
        strokeWidth={small ? 4 : 4}
        styles={buildStyles({
          pathColor: COLORS.primaryViolet,
          trailColor: COLORS.violetLight,
        })}
      >
        <div
          className={twMerge(
            small ? 'p-2' : 'p-4',
            'flex h-full w-full items-center justify-center rounded-full object-cover',
          )}
        >
          {children}
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
};

export default TierAvatarProgress;
